// source: pbtypes/gen/scan_planner/coverage_mesh_component.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_scan_output_scan_coverage_parameters_pb = require('../../../pbtypes/gen/scan_output/scan_coverage_parameters_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_output_scan_coverage_parameters_pb);
var pbtypes_gen_scan_planner_scan_photo_pb = require('../../../pbtypes/gen/scan_planner/scan_photo_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_planner_scan_photo_pb);
goog.exportSymbol('proto.scan_planner.CoverageMeshComponent', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_planner.CoverageMeshComponent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.scan_planner.CoverageMeshComponent.repeatedFields_, null);
};
goog.inherits(proto.scan_planner.CoverageMeshComponent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_planner.CoverageMeshComponent.displayName = 'proto.scan_planner.CoverageMeshComponent';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.scan_planner.CoverageMeshComponent.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_planner.CoverageMeshComponent.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_planner.CoverageMeshComponent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_planner.CoverageMeshComponent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.CoverageMeshComponent.toObject = function(includeInstance, msg) {
  var f, obj = {
photoListList: jspb.Message.toObjectList(msg.getPhotoListList(),
    pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto.toObject, includeInstance),
coverageParameters: (f = msg.getCoverageParameters()) && pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters.toObject(includeInstance, f),
isExploration: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
cameraCropFraction: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
binaryCoverage: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
maxNumPhotos: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_planner.CoverageMeshComponent}
 */
proto.scan_planner.CoverageMeshComponent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_planner.CoverageMeshComponent;
  return proto.scan_planner.CoverageMeshComponent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_planner.CoverageMeshComponent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_planner.CoverageMeshComponent}
 */
proto.scan_planner.CoverageMeshComponent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto;
      reader.readMessage(value,pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto.deserializeBinaryFromReader);
      msg.addPhotoList(value);
      break;
    case 2:
      var value = new pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters;
      reader.readMessage(value,pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters.deserializeBinaryFromReader);
      msg.setCoverageParameters(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsExploration(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setCameraCropFraction(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBinaryCoverage(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMaxNumPhotos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_planner.CoverageMeshComponent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_planner.CoverageMeshComponent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_planner.CoverageMeshComponent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.CoverageMeshComponent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPhotoListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto.serializeBinaryToWriter
    );
  }
  f = message.getCoverageParameters();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters.serializeBinaryToWriter
    );
  }
  f = message.getIsExploration();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getCameraCropFraction();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getBinaryCoverage();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getMaxNumPhotos();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
};


/**
 * repeated ScanPhoto photo_list = 1;
 * @return {!Array<!proto.scan_planner.ScanPhoto>}
 */
proto.scan_planner.CoverageMeshComponent.prototype.getPhotoListList = function() {
  return /** @type{!Array<!proto.scan_planner.ScanPhoto>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto, 1));
};


/**
 * @param {!Array<!proto.scan_planner.ScanPhoto>} value
 * @return {!proto.scan_planner.CoverageMeshComponent} returns this
*/
proto.scan_planner.CoverageMeshComponent.prototype.setPhotoListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.scan_planner.ScanPhoto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.scan_planner.ScanPhoto}
 */
proto.scan_planner.CoverageMeshComponent.prototype.addPhotoList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.scan_planner.ScanPhoto, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scan_planner.CoverageMeshComponent} returns this
 */
proto.scan_planner.CoverageMeshComponent.prototype.clearPhotoListList = function() {
  return this.setPhotoListList([]);
};


/**
 * optional scan_output.ScanCoverageParameters coverage_parameters = 2;
 * @return {?proto.scan_output.ScanCoverageParameters}
 */
proto.scan_planner.CoverageMeshComponent.prototype.getCoverageParameters = function() {
  return /** @type{?proto.scan_output.ScanCoverageParameters} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters, 2));
};


/**
 * @param {?proto.scan_output.ScanCoverageParameters|undefined} value
 * @return {!proto.scan_planner.CoverageMeshComponent} returns this
*/
proto.scan_planner.CoverageMeshComponent.prototype.setCoverageParameters = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_planner.CoverageMeshComponent} returns this
 */
proto.scan_planner.CoverageMeshComponent.prototype.clearCoverageParameters = function() {
  return this.setCoverageParameters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_planner.CoverageMeshComponent.prototype.hasCoverageParameters = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool is_exploration = 3;
 * @return {boolean}
 */
proto.scan_planner.CoverageMeshComponent.prototype.getIsExploration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.CoverageMeshComponent} returns this
 */
proto.scan_planner.CoverageMeshComponent.prototype.setIsExploration = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional float camera_crop_fraction = 4;
 * @return {number}
 */
proto.scan_planner.CoverageMeshComponent.prototype.getCameraCropFraction = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.CoverageMeshComponent} returns this
 */
proto.scan_planner.CoverageMeshComponent.prototype.setCameraCropFraction = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional bool binary_coverage = 5;
 * @return {boolean}
 */
proto.scan_planner.CoverageMeshComponent.prototype.getBinaryCoverage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.CoverageMeshComponent} returns this
 */
proto.scan_planner.CoverageMeshComponent.prototype.setBinaryCoverage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional uint32 max_num_photos = 6;
 * @return {number}
 */
proto.scan_planner.CoverageMeshComponent.prototype.getMaxNumPhotos = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.CoverageMeshComponent} returns this
 */
proto.scan_planner.CoverageMeshComponent.prototype.setMaxNumPhotos = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


goog.object.extend(exports, proto.scan_planner);
